import { DateFormat, formatIsoDate } from '~/common/util/dateUtil'
import type { Iso8601Timestamp } from '~/common/model'

export const renderDataTableDate = (value: Iso8601Timestamp) => formatIsoDate(value.toString(), DateFormat.ShortDate)
